import { connect } from 'react-redux';
import { subscribeToTier, pushUnsubscribeModal, } from '../../Tier/redux/consumer/actions';
import { isConsumerReduxReady, isMatureFilterOverridden, } from '../../Tier/redux/consumer/selectors';
var mapStateToProps = function (state, ownProps) { return ({
    reduxReady: isConsumerReduxReady(state),
    matureFilterOverridden: isMatureFilterOverridden(state, ownProps.tier.deviationId)
}); };
var mapDispatchToProps = {
    onSubscribe: subscribeToTier,
    onUnsubscribe: pushUnsubscribeModal,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=SubscribeButton.container.js.map